module.exports = __webpack_public_path__ + "img/icon_bt.40cdd766.svg";